/* eslint-disable */
import ResortsRepository from '../Repository/Resorts';

const CountryEntity = Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        isPopular: null,
        position: null,
        regionTourCriteria: null,
        capitalTourCriteria: null,
        visaRequired: null,
        visaDays: null,
        visaOnline: null,
        resorts: null,
        tourCriteria: null,
        nameEng: null,
        minPrice: null,
    },
    cache: {},
    getResorts(callback, params) {
        let retryCount = 0;
        let timerId;
        const retryLimit = 3;
        const resorts = this.get('resorts');
        const countryId = this.get('id');
        const dataType = params?.dataType || 'jsonp';
        const self = this;

        let cacheData = self.cache[countryId];
        const options = {
            url: window.appConfig && window.appConfig.getResorts ? (window.appConfig.gatewayUrl + window.appConfig.getResorts) : '',
            data: {
                country: countryId,
                dc: window.appConfig.showcaseDC,
            },
            dataType,
        };
        const createAjaxRequest = function () {
            return new Promise((resolve, reject) => {
                const nestedCall = () => {
                    $.ajax(options)
                    .success(function (response) {
                        if (response.success === true) {
                            const resortsCollection = new ResortsRepository();

                            _.each(response.data, (resort) => {
                                resort.country = self;
                                return resort;
                            });
                            resortsCollection.addEntry(response.data, { merge: true });

                            resolve(resortsCollection);
                            self.cache[countryId] = true;
                        } else {
                            reject(this, response.message);
                        }
                    })
                    .fail((XMLHttpRequest, textStatus, errorThrown) => {
                        const {
                            status,
                        } = XMLHttpRequest;

                        const shouldRetry = !status || (status && status < 600 && status >= 500);

                        if (shouldRetry && dataType === 'json') {
                            // TrackJS.track(`Retry code: ${status}, retryCount: ${retryCount}, textStatus: ${textStatus}`);
                            
                            if (timerId) {
                                clearTimeout(timerId);
                            }
                            if (textStatus === 'error') {
                                retryCount++;

                                if (retryCount <= retryLimit) {
                                    timerId = setTimeout(() => {
                                        options.data = { ...options.data, retryCount };

                                        nestedCall();
                                    }, 2000);
                                } else {
                                    reject(XMLHttpRequest, textStatus, errorThrown);
                                }
                            }
                        } else {
                            reject(XMLHttpRequest, textStatus, errorThrown);
                        }
                    });
                };

                nestedCall();
            });
        };
        const fail = function (textStatus) {
            callback && callback.error ? callback.error() : '';
            if (textStatus !== 'abort') {
                console.log(textStatus);
                console.log(options);
                // TrackJS.track('No resorts returned!!');
            }
        };

        if (cacheData && !(cacheData instanceof Promise) && resorts) {
            callback && callback.success ? callback.success(resorts) : '';
        } else {
            if (!(cacheData && cacheData instanceof Promise)) {
                cacheData = self.cache[countryId] = createAjaxRequest();
            }

            cacheData.then((resortsCollection) => {
                self.set('resorts', resortsCollection);
                callback && callback.success ? callback.success(resortsCollection) : '';
            }, (XMLHttpRequest, textStatus, errorThrown) => {
                fail(textStatus);
            });
        }
    },
});

export default CountryEntity;